<div class="page-body">
  <div *ngIf="pollingInProgress" class="polling-overlay">
    <app-spinner [infoText]="'Iban wird geprüft...'"> </app-spinner>
  </div>

  <div *ngIf="internalServerError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">Etwas ist schief gelaufen.</h3>
      <p class="info-text">
        Bitte versuchen Sie es erneut. Kontaktieren Sie uns, wenn das Problem
        weiterhin besteht.
      </p>
    </div>
  </div>

  <div *ngIf="loading && !internalServerError">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !internalServerError" class="contents-wrapper">
    <div class="contents-container">
      <app-zaver-icon class="icon-user-img" [size]="80" name="bankSignalCircle" ></app-zaver-icon>
      <h1 class="heading">Von welchem Bankkonto möchten Sie&nbsp;bezahlen?</h1>
      <p class="info-text">Geben Sie dazu hier Ihre IBAN ein.</p>

      <form [formGroup]="form">
        <div class="input-container">
          <zaver-form-input
            appIbanFormatter
            [size]="'large'"
            [formControlName]="'iban'"
            [error]="form.controls.iban.invalid && showError"
            [errorMessage]="'Bitte geben Sie eine gültige IBAN ein'"
            [showContent]="true"
            ><span class="iban-input-text">IBAN</span>
          </zaver-form-input>

          <div *ngIf="isIbanVerified" class="bank-info-container">
            <div *ngIf="verifiedBankIconUrl; else bankText">
              <img class="bank-icon" [src]="verifiedBankIconUrl" alt="Bank:" />
            </div>

            <ng-template #bankText>
              <span class="bank-name-prefix">Bank:</span>
            </ng-template>

            <span class="bank-name">{{ verifiedBankName }}</span>

            <app-zaver-icon *ngIf="isIbanVerified" [size]="11" name="checkmark" ></app-zaver-icon>
          </div>

          <div *ngIf="disableForm" class="iban-invalid-container">
            <app-zaver-icon [size]="22" name="warning" ></app-zaver-icon>
            <span
              >Die eingebebene IBAN ist gültig, allerdings müssen wir
              sicherstellen, dass diese auch Ihnen gehört. Bitte melden Sie sich
              im nächsten Schritt mit Ihrem Bankkonto an.</span
            >
          </div>
        </div>
      </form>

      <a *ngIf="!disableForm" class="ais-link" (click)="initiateAIS()">
        Keine IBAN zur Hand? Hier in Ihr Bankkonto einloggen und IBAN festlegen.
      </a>

      <p class="sub-info-text">
        Wenn Sie auf "Weiter" klicken, ermächtigen Sie Frink AB (Zaver),
        Anweisungen an Ihre Bank zu senden, um Ihr Konto gemäß dem
        Sepa-Lastschriftmandat zu belasten. Um Betrug zu vermeiden, prüfen wir
        ob die IBAN zu Ihrer Person gehört.<br />
        <a class="terms-btn" (click)="openModalWithTerms()">
          Bedingungen ansehen
        </a>
      </p>

      <zaver-checkout-modal
        *ngIf="modalActive"
        [buttonText]="'Schließen'"
        [logo]="'assets/img/Zaver_Logotype_Circle_Coal_DE.svg'"
        (onClose)="deactivateModal()"
      >
        <app-selector
          #selector
          *ngIf="!!selectorItems"
          [selectorItems]="selectorItems"
          [selectedItem]="selectedItem"
        ></app-selector>
      </zaver-checkout-modal>

      <div class="footer-wrapper">
        <div class="footer-container">
          <div class="button-container">
            <zaver-primary-button
              [text]="getButtonText()"
              [disabled]="navigationInProgress || !isIbanVerified"
              (click)="handleCtaClick()"
            ></zaver-primary-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
